<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CUXUJf/tc-custom/9781497674493.jpg?1702092112856" alt="This image is the cover for the book Parade of Shadows"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Parade of Shadows
      </h1>
      <p class="bookDescription body article font2">
        <b>At the dawn of the Young Turk Revolution, an English girl goes on the adventure of a lifetime</b><br/><br/> For years Julia has stared at her globe, dreaming of countries on the other side of the earth. In 1907, when her father is assigned to go on a diplomatic mission to the exotic Ottoman Empire, Julia begs him not to leave her alone in the house that has been empty since her mother died. Although Julia is only sixteen and young women rarely travel abroad, her father relents. She will accompany him on his trip—seeing sights she never dreamed of that will change her life forever.<br/><br/> The land of the Turks is in the first days of a rebellion, and Julia’s father has come to assess the revolt. In the endless deserts of Syria, Julia encounters ruins too old to be imagined, fascinating people, romance, and a revolution that will move her in ways she never thought possible.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gloria Whelan
      </h2>
      
      <p class="authorDescription body article">&amp;lt;p&amp;gt;Gloria Whelan is the bestselling author of many novels for young readers, including &amp;lt;em&amp;gt;Homeless Bird&amp;lt;/em&amp;gt;, winner of the National Book Award; &amp;lt;em&amp;gt;Fruitlands: Louisa May Alcott Made Perfect&amp;lt;/em&amp;gt;; &amp;lt;em&amp;gt;Angel on the Square&amp;lt;/em&amp;gt;; &amp;lt;em&amp;gt;Burying the Sun&amp;lt;/em&amp;gt;; &amp;lt;em&amp;gt;Once on This Island&amp;lt;/em&amp;gt;, winner of the Great Lakes Book Award; and &amp;lt;em&amp;gt;Return to the Island&amp;lt;/em&amp;gt;. She lives in the woods of northern Michigan.&amp;lt;/p&amp;gt;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6ae42596